<template>
  <div>
    <img :src="require(`@/assets/${path}.png`)" :class="listType" />
  </div>
</template>

<script>
export default {
  name: 'ProductLogo',
  props: {
    name: {
      type: String,
      required: true,
    },
    list: {
      type: String,
      default: () => 'productList',
      validator: value => ['productList', 'otherProductList'].indexOf(value) !== -1,
    },
  },
  computed: {
    path() {
      return this.name.includes('canadian')
        ? this.enums.SpotlightConstants.internalNames.firstCanadian.BREAKDOWN
        : this.name;
    },
    listType() {
      return this.list === 'productList' ? 'product-list' : 'other-product-list';
    },
  },
};
</script>

<style scoped>
img {
  width: 80px;
}
.product-list {
  margin-bottom: 16px;
}
.other-product-list {
  margin-bottom: 8px;
}
</style>
